import { render } from "./Fatca.vue?vue&type=template&id=5380b50e&scoped=true"
import script from "./Fatca.vue?vue&type=script&lang=js"
export * from "./Fatca.vue?vue&type=script&lang=js"

import "./Fatca.vue?vue&type=style&index=0&id=5380b50e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5380b50e"]])

export default __exports__